(function ($, Drupal) {
  Drupal.behaviors.MapHelper = {
    attach: function attach(context, settings) {
      if ($(".map-component").length != 1) return;

      var options = {
        zoom: 2,
        center: new google.maps.LatLng(12.3388244, -71.5973016),
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        styles: [
          {
            featureType: "administrative",
            elementType: "labels.text.fill",
            stylers: [{ color: "#7d8d97" }]
          },
          {
            featureType: "landscape",
            elementType: "all",
            stylers: [{ color: "#f2f2f2" }]
          },
          {
            featureType: "landscape",
            elementType: "geometry.fill",
            stylers: [{ color: "#f2f5f6" }]
          },
          {
            featureType: "poi",
            elementType: "all",
            stylers: [{ visibility: "off" }]
          },
          {
            featureType: "poi.attraction",
            elementType: "all",
            stylers: [{ visibility: "off" }]
          },
          {
            featureType: "poi.park",
            elementType: "geometry.fill",
            stylers: [{ color: "#e6f3d6" }, { visibility: "off" }]
          },
          {
            featureType: "road",
            elementType: "all",
            stylers: [
              { saturation: -100 },
              { lightness: 45 },
              { visibility: "off" }
            ]
          },
          {
            featureType: "road.highway",
            elementType: "all",
            stylers: [{ visibility: "off" }]
          },
          {
            featureType: "road.highway",
            elementType: "geometry.fill",
            stylers: [{ color: "#f4d2c5" }, { visibility: "simplified" }]
          },
          {
            featureType: "road.highway",
            elementType: "labels.text",
            stylers: [{ color: "#4e4e4e" }]
          },
          {
            featureType: "road.arterial",
            elementType: "geometry.fill",
            stylers: [{ color: "#f4f4f4" }]
          },
          {
            featureType: "road.arterial",
            elementType: "labels.text.fill",
            stylers: [{ color: "#787878" }]
          },
          {
            featureType: "road.arterial",
            elementType: "labels.icon",
            stylers: [{ visibility: "off" }]
          },
          {
            featureType: "transit",
            elementType: "all",
            stylers: [{ visibility: "off" }]
          },
          {
            featureType: "water",
            elementType: "all",
            stylers: [
              { visibility: "on" },
              { hue: "#ff0000" },
              { saturation: "-100" },
              { lightness: "45" }
            ]
          },
          {
            featureType: "water",
            elementType: "geometry.fill",
            stylers: [{ color: "#cddbe2" }]
          }
        ]
      };

      var locations = [];

      $.ajax({
        url: "/rest/export/offices?_format=json"
      }).then(function (data) {
        for (var i in data) {
          var pinData = '<div class="info-window">';
          if (typeof data[i].address !== "undefined") {
            pinData = pinData + data[i].address + "<br/>";
          }
          if (data[i].telephone) {
            pinData = pinData + "tel: " + data[i].telephone + "<br/>";
          }
          if (data[i].fax) {
            pinData = pinData + "fax: " + data[i].fax + "<br/>";
          }
          if (typeof data[i].email) {
            pinData =
              pinData +
              '<a href="mailto:' +
              data[i].email +
              '">' +
              data[i].email +
              "</a><br/>";
          }
          if (data[i].website) {
            pinData = pinData + data[i].website;
          }
          pinData = pinData + "</div>";
          var location = [
            data[i].office_name,
            data[i].latitude,
            data[i].longitude,
            4,
            pinData
          ];

          locations.push(location);
        }

        var map = new google.maps.Map(document.getElementById("map"), options);
        var infowindow = new google.maps.InfoWindow();
        var marker, i;
        var markerIcon = "/themes/custom/onespan/images/marker.png";

        for (i = 0; i < locations.length; i++) {
          marker = new google.maps.Marker({
            position: new google.maps.LatLng(locations[i][1], locations[i][2]),
            map: map,
            icon: markerIcon
          });

          google.maps.event.addListener(
            marker,
            "click",
            (function (marker, i) {
              return function () {
                infowindow.setContent(locations[i][4]);
                infowindow.open(map, marker);
              };
            })(marker, i)
          );
        }
      });
    }
  };
})(jQuery, Drupal);
